import React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import moment from 'moment';
require('highcharts/modules/exporting')(Highcharts);
const LgGraph = ({lgData,lgGraphType, callExternalFunction, tabIndex}) => {
    let aircraftTypes = lgData?.aircraft_type || []
    let avgMrRate = lgData?.total_mr_rate || []
    let avgSvCost = lgData?.total_sv_cost || []
    const options = {
        chart: {
            type: lgGraphType == 1 ?'column': 'line',
        },
    
        title: {
            text: ''
        },
    
        subtitle: {
            text: ''
        },
    
        xAxis: {
            categories: aircraftTypes
        },
    
        yAxis: [{ // Primary axis
            className: 'highcharts-color-0',
            title: {
                text: 'Lg Cost (US$)'
            }
        }, { // Secondary axis
            className: 'highcharts-color-1',
            opposite: true,
            title: {
                text: 'MR Rate (US$)'
            }
        }],
    
        plotOptions: {
            column: {
                borderRadius: 5,
                point: {
                    events: {
                      click: function( item , index) {
                        tabIndex == 'generic' ? console.log(''):
                        callExternalFunction('lg',
                        {xData:item?.point?.category, yData:item?.point?.series?.name, value:item?.point?.y});
                      }
                    }
                  }
            },
            line: {
                point: {
                    events: {
                      click: function( item , index) {
                        tabIndex == 'generic' ? console.log(''):
                        callExternalFunction('lg',
                        {xData:item?.point?.category, yData:item?.point?.series?.name, value:item?.point?.y});
                      }
                    }
                  }
            }
        },
    
        series: [{
            name: 'LG Cost',
            color:'#0066FF',
            data: avgSvCost,
            tooltip: {
                valuePrefix: ' US$'
            }
        }, {
            name: 'MR Rate',
            data: avgMrRate,
            color:'#F9AC2A',
            yAxis: 1,
            tooltip: {
                valueSuffix: '/ Month',
                valuePrefix: ' US$'
            }
        }],
        credits: {
            enabled: false
        },
    }
    return(
        <div>
            <HighchartsReact
                highcharts={Highcharts}
                options={options}
            />
        </div>
    )
}
export default LgGraph;
